import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/sets";

export const listAllSets = async (query: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.get(url, {
      params: query,
    });
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getSetById = async (id: string) => {
  try {
    let url = `${endpoint}/${id}`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const createSet = async (templateData: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.post(url, templateData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updateSet = async (templateId: number, templateData: any) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.put(url, templateData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const duplicateSetById = async (setId: any) => {
  try {
    let url = `${endpoint}/${setId}/duplicate`;
    const result = await adminApi.post(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const deleteSet = async (templateId: string) => {
  try {
    let url = `${endpoint}/${templateId}`;
    const result = await adminApi.delete(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
